import { render, staticRenderFns } from "./RoleGrantRefs.vue?vue&type=template&id=6b8a7881&scoped=true&"
import script from "./RoleGrantRefs.vue?vue&type=script&lang=js&"
export * from "./RoleGrantRefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a7881",
  null
  
)

export default component.exports